import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
	Row, ButtonGroup, Button, Col,
} from 'react-bootstrap';
import { isEqual } from 'lodash';
import classNames from 'classnames';
import constants from '@constants';
import { ExpandableContext } from '@components/contexts';
import { thunks } from '@redux/jobs';
import { SearchField } from '@components/common';

class SubMenu extends Component {
	static gerDerivedStateFromProps(nextProps, lastState) {
		const view = nextProps.pathname.split('/')[2] || 'list';

		if (!isEqual(view, lastState.view)) return { view };

		return null;
	}

	constructor(props) {
		super(props);
		const view = props.pathname.split('/')[2] || 'list';

		this.state = {
			view,
		};
	}

	shouldComponentUpdate = ({
		label,
		totalCount,
		search,
		activePage,
		filter,
	}, { view }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(totalCount, lastProps.totalCount)
			|| !isEqual(label, lastProps.label)
			|| !isEqual(activePage, lastProps.activePage)
			|| !isEqual(search, lastProps.search)
			|| !isEqual(filter, lastProps.filter)
			|| !isEqual(view, lastState.view)
		);
	}

	onQuickSearch = (jobId) => {
		const { goToJob } = this.props;
		goToJob(jobId);
	}

	render() {
		const {
			totalCount,
			search,
			label,
			activePage,
			viewType,
		} = this.props;
		const { view } = this.state;
		const jobType = constants.JOB_TYPES_MAP.find(({ name }) => name === viewType) || 'active';
		const isListView = view === 'list';
		const isMapView = view === 'map';

		return (
			<div className="search-bar jobs-page">
				<Row className="flex flex-align-items-center">
					<Col
						md={4}
						sm={4}
					>
						<h3>
							{ activePage === 'needApproval' ? 'Need Approval / Payment' : `${jobType.displayName} ${label}` }
							<span>
								(
								{ totalCount }
								)
							</span>
						</h3>
						<If condition={activePage !== 'needApproval'}>
							<div className="legends">
								<div>
									<i className="fa fa-circle color-green-limeade" />
									<span>Fully Staffed</span>
								</div>
								<div>
									<i className="fa fa-circle color-yellow-buttercup" />
									<span>Understaffed</span>
								</div>
								<div>
									<i className="fa fa-circle color-red-torch" />
									<span>Unstaffed</span>
								</div>
							</div>
						</If>
					</Col>
					<If condition={activePage !== 'needApproval'}>
						<Col
							md={3}
							sm={3}
						>
							<SearchField
								placeholder="Search by Job ID"
								onQuickSearch={this.onQuickSearch}
							/>
						</Col>
					</If>
					<Col
						md={activePage !== 'needApproval' ? 5 : 8}
						sm={activePage !== 'needApproval' ? 5 : 8}
						className="actions"
					>
						<ExpandableContext.Consumer>
							{({ expanded, onToggle }) => (
								<Button
									title="Filters"
									onClick={onToggle}
									bsStyle={expanded ? 'primary' : undefined}
									className="btn-white-gray btn-stand-alone"
								>
									<i className="rkf rkf-filters" />
								</Button>
							)}
						</ExpandableContext.Consumer>
						<If condition={activePage !== 'needApproval'}>
							<ButtonGroup>
								<Link
									to={`/jobs/list/${viewType || 'active'}${search}`}
									className={classNames('btn btn-white-gray', {
										'btn-primary' : isListView,
									})}
								>
									<i className="rkf rkf-bars" />
									{' '}
									List View
								</Link>
								<Link
									to={`/jobs/map/${viewType || 'active'}${search}`}
									className={classNames('btn btn-white-gray', {
										'btn-primary' : isMapView,
									})}
								>
									<i className="fa fa-fw fa-map" />
									{' '}
									Map View
								</Link>
							</ButtonGroup>
						</If>
					</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = ({
	router : {
		location : { pathname, search },
		match : { params : { viewType } },
	},
	jobs    : {
		totalCount,
		filter : { type },
	},
}) => ({
	pathname,
	search,
	totalCount,
	viewType,
	filter : { type },
});

const mapDispatchToProps = (dispatch) => ({
	goToJob : bindActionCreators(thunks, dispatch).goToJob,
});

SubMenu.propTypes = {
	activePage : PropTypes.string,
	goToJob    : PropTypes.func.isRequired,
	label      : PropTypes.string,
	pathname   : PropTypes.string,
	search     : PropTypes.string,
	totalCount : PropTypes.number,
	viewType   : PropTypes.string.isRequired,
	filter     : PropTypes.object.isRequired,
};

SubMenu.defaultProps = {
	activePage : '',
	label      : '',
	pathname   : '',
	search     : '',
	totalCount : 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubMenu);
